export default __webpack_public_path__ + "static/media/Helvetica.06113bf7.ttf";